import Select from "./Select";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default Select;
